
<div class="tw-p-3.5 tw-bg-[#e9ecef]/50 tw-grow" [class.tw-bg-white]="backgroundWhite">
  <ng-content></ng-content>
</div>
